import styled from 'styled-components'

export const CharacterCountList = styled.li`
  display: flex;
  list-style: none;
  margin-bottom: 8px;
`
export const ResultText = styled.p`
  font-family: Roboto;
  font-size: 20px;
  color: #272c47;
  font-weight: bold;
  padding: 0px;
  margin: 0px;
`
export const SpanText = styled.span`
  font-size: 25px;
`
